<template>
  <div class="topBox" :class="{ topBoxblack: isScroll, showmenu: hoverIndex > -1 }">
    <div class="navbar">
      <div class="login-btn">
        <img @click="handleToLog" class="icon" :src="$env.imgUrl + 'login.png'" alt="">
        <img class="icon" :src="$env.imgUrl + 'search.png'" alt="">
      </div>
      <div class="logo">
        <img :src="$env.imgUrl + 'PBLLOGO.png'" alt="">
      </div>
      <div class="menu-list">
        <div class="menu-item" :class="{ active: active === index, 'has-child': item.childList }"
             v-for="(item, index) in menuList" :key="index"
             @click="jumpFn(index, item.linkStr)"
             @mouseenter="hoverIndex = index"
             @mouseleave="hoverIndex = -1"
             >
          <div class="cn">{{ item.title }}</div>
          <div class="en">{{ item.enTitle }}</div>
          <!-- hover 下拉子菜单 -->
          <transition name="dropdown">
            <div class="child-menu" v-if="item.childList && hoverIndex === index && isScroll">
              <div class="child-menu-item" :class="active === index && activeIndex === j ? 'active' : ''" v-for="(value, j) in item.childList" :key="j"
                   @click.stop="handleChildClick(item.linkStr, index, j)">
                <div class="child-menu-item-cn">{{ value.title }}</div>
                <div class="child-menu-item-en">{{ value.enTitle }}</div>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
    <!-- 额外占位，滚动时能看到导航栏固定在顶部 -->
    <div class="scroll-placeholder"></div>
  </div>
</template>

<script>
export default {
  name: 'app',
  props: {
    isScroll: {
      type: Boolean
    }
  },
  data () {
    return {
      active: 0,
      activeIndex: 0,
      isScrolled: false,
      hoverIndex: -1, // 当前 hover 的菜单索引
      menuList: [
        {
          title: '首页',
          enTitle: 'Home',
          linkStr: '/homeView'
        },
        {
          title: '关于我们',
          enTitle: 'About Us',
          linkStr: '/about',
          childList: [
            { title: '项目发展背景', enTitle: 'Project Development Background' },
            { title: '项目完整体系', enTitle: 'Complete Program System' }
          ]
        },
        {
          title: '全球青少年PBL创新素养挑战赛',
          enTitle: 'PBL Innovation Challenge',
          linkStr: '/pbl',
          childList: [
            { title: '赛事完整概况', enTitle: 'Full Competition Overview' },
            { title: '2026四大领域', enTitle: '2026 Four Key Areas' },
            { title: '战队注册体系', enTitle: 'Team Registration System' },
            { title: '专业评审体系', enTitle: 'Professional Judge System' }
          ]
        },
        {
          title: '学习调研',
          enTitle: 'Program Investigation and Learning',
          linkStr: '/study',
          childList: [
            { title: '校内实施路径', enTitle: 'Pathways for Implementing PBL in Schools' },
            { title: '教师成长赋能', enTitle: 'Empowering Teacher Growth' },
            { title: '官方赛前支持', enTitle: 'Official Pre-Match Support' }
          ]
        },
        {
          title: '真实探究',
          enTitle: 'Real World Explore',
          linkStr: '/explore',
          childList: [
            { title: '主题探究方案', enTitle: 'Thematic Inquiry Plan' },
            { title: '非遗主题探究', enTitle: 'Exploring Intangible Cultural Heritage ' },
            { title: '官方权威认证', enTitle: 'Official and authoritative certification' }
          ]
        }
      ]
    }
  },
  watch: {
    '$route' (to) {
      this.activeIndex = to.query.index ? Number(to.query.index) : 0
    },
    screenWidth: {
      handler: function (val) {
        if (val < 1050) {
          this.isWidth = false
        } else {
          this.isWidth = true
        }
      },
      immediate: true
    }
  },
  mounted () {
    const userInfoData = JSON.parse(localStorage.getItem('saveUserInfo'))
    this.userName = userInfoData ? userInfoData.userName : '游客'
    this.screenWidth = document.body.clientWidth
    this.nowMenuList = this.menuList
    window.onresize = () => {
      this.screenWidth =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth
    }
    this.active = this.$store.state.menuIndex
    this.activeIndex = this.$route.query.index ? Number(this.$route.query.index) : 0
    this.$store.dispatch('SET_MENUINDEX', this.active)
  },
  methods: {
    handleSelect (key, keyPath) {
      console.log(key, keyPath)
    },
    goTohome () {
      this.$router.push('/')
    },
    LookOrderGrab () {
      window.open('http://t1.ink/f/xzacwe')
    },
    handleCommand (command) {
      // console.log('nowMenuList', this.nowMenuList)
      const selectMenu = this.nowMenuList[command]
      if (selectMenu.linkStr === 'back') {
        this.nowMenuList = this.lastMenuList
      } else if (selectMenu.linkStr === 'childMenu') {
        // 只支持二级菜单，如果有三级菜单还需要完善lastMenuList逻辑
        this.lastMenuList = this.nowMenuList
        this.nowMenuList = selectMenu.childList
      } else {
        console.log('跳转链接', selectMenu.linkStr)
        this.$router.push(selectMenu.linkStr)
      }
    },
    menuClicked () {
      this.nowMenuList = this.menuList
    },
    handleToLog () {
      if (this.userName === '游客') {
        this.$router.push('/loginview')
      } else {
        this.$router.push('/userInfo_personalData')
      }
    },
    handleToReg () {
      const token = localStorage.getItem('HQAuthorization')
      if (token) {
        this.$router.push('/club/register?step=0')
      } else {
        this.$router.push('/loginview')
      }
    },
    jumpFn (index, linkStr) {
      this.active = index
      this.$store.dispatch('SET_MENUINDEX', this.active)
      if (linkStr && linkStr !== 'childMenu') {
        this.$router.push(linkStr)
      }
    },
    handleChildClick (linkStr, i, j) {
      this.active = i
      this.$store.dispatch('SET_MENUINDEX', this.active)
      this.hoverIndex = -1
      this.$router.push(`${linkStr}?index=${j}`)
    }
  }
}
</script>

<style lang="less" scoped>
.topBox{
  width: 100vw;
  height: 124px;
  position: relative;
  &.showmenu{
    overflow: visible;
  }
}
.logo{
  text-align: center;
  padding: 16px 0;
  img{
    height: 34px;
  }
}
.navbar {
  /* 固定在顶部 */
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;

  /* ① 初始白色半透明背景 */
  background: rgba(255, 255, 255, 0.1);
  /* ② ⭐核心：背景模糊（只模糊背后的图片） */
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px); /* Safari 兼容 */
  /* ③ 玻璃质感细节 */
  border-bottom: 1px solid rgba(255, 255, 255, .25);
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
  /* 过渡效果 */
  transition: background 0.3s ease, box-shadow 0.3s ease;
}

/* 滚动超过 200px 后：背景变深 */
.navbar.scrolled {
  background: rgba(0, 0, 0, 0.65);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.25);
}
/* 滚动占位，让你看到导航栏固定在顶部 */
.scroll-placeholder {
  height: 200vh;
  background: linear-gradient(transparent, rgba(0,0,0,0.3));
}
.login-btn{
  position: absolute;
  right: 60px;
  top: 18px;
  .icon{
    width: 36px;
    height: 36px;
    margin-right: 12px;
    cursor: pointer;
  }
}
.menu-list{
  display: flex;
  align-items: center;
  justify-content: center;
  height: 54px;
  .menu-item{
    color: rgba(255,255,255,.6);
    font-size: 14px;
    margin: 0 30px;
    text-align: center;
    position: relative;
    padding: 0 20px;
    cursor: pointer;
    height: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    .icon{
      position: absolute;
      right: -6px;
      top: 8px;
      font-size: 16px;
    }
    .en{
      font-size: 10px;
    }
    &.active{
      color: #fff;
      font-weight: bold;
      position: relative;
      &::after{
        content: '';
        display: block;
        width: 90px;
        height: 3px;
        background-color: #FFF;
        position: absolute;
        left: calc(50% - 45px);
        bottom: 3px;
      }
    }
    // 子菜单通过全局 .child-menu 样式控制（见下方）
  }
}

// 子菜单样式（全局，供正常/滚动两种状态共用）
.child-menu{
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.65);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  padding: 10px 0;
  min-width: 240px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.35);
  z-index: 2000;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-top: none;
  .child-menu-item{
    padding: 10px 24px;
    cursor: pointer;
    transition: background 0.25s ease;
    text-align: center;
    .child-menu-item-cn{
      font-size: 13px;
      color: rgba(255, 255, 255, 0.6);
      line-height: 18px;
    }
    .child-menu-item-en{
      font-size: 10px;
      color: rgba(255, 255, 255, 0.6);
      line-height: 14px;
      margin-top: 2px;
    }
    &:hover, &.active{
      background: rgba(255, 255, 255, 0.1);
      .child-menu-item-cn{ color: #fff; }
      .child-menu-item-en{ color: #fff; }
    }
  }
}
// 有子菜单项显示向下箭头
// .has-child .cn::after{
//   content: '';
//   display: inline-block;
//   width: 0;
//   height: 0;
//   border-left: 4px solid transparent;
//   border-right: 4px solid transparent;
//   border-top: 5px solid rgba(255,255,255,0.5);
//   margin-left: 6px;
//   vertical-align: middle;
//   transition: transform 0.3s ease, border-top-color 0.3s;
// }
// .has-child:hover .cn::after,
// .has-child.active .cn::after{
//   border-top-color: #fff;
//   transform: rotate(180deg);
// }
// 下拉动画
.dropdown-enter-active,
.dropdown-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}
.dropdown-enter,
.dropdown-leave-to {
  opacity: 0;
  transform: translateX(-50%) translateY(-8px);
}

.topBoxblack{
  height: 64px;
  .navbar{
    padding-left: 30px;
    padding-right: 100px;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .menu-list{
    height: 100%;
    .menu-item{
      margin: 0 14px;
    }
    .active::after{
      content: '';
      bottom: 0;
    }
  }
  .login-btn{
    top: 14px;
    right: 10px;
  }
}

</style>
